module.exports = __webpack_public_path__ + "static/img/客户案例-004.aaf16f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cases/客户案例-004.png
// module id = ksL+
// module chunks = 94